import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Menu,
} from "@mui/material";
import { RgbaColorPicker, HexColorPicker } from "react-colorful";
import { button_bg_color_for_New_Project } from "../../../../constants/colors";

const ColorPalette = ({
  anchorEl,
  handleCloseColorPalette,
  color,
  setColor,
  selectedcolor,
}) => {
  const theme = localStorage.getItem("theme");
  const [tempColor, setTempColor] = useState(color);
  const [tempColorRgbCode, setTempColorRgbCode] = useState({r:0,g:0,b:0});


  useEffect(() => {
    setTempColor(color);
  }, [color]);

    const hexToRgb = (hex) => {
    hex = hex.replace(/^#/, "");
  
    if (hex.length === 3) {
      hex = hex.split("").map((char) => char + char).join("");
    }
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return { r, g, b };
  };
  
  useEffect(()=>{
     if(tempColor != "#FFFFFF" || "#ffffff"){
        setTempColorRgbCode(hexToRgb(tempColor))
      }
  },[tempColor])


  const handleSave = () => {
    setColor(tempColor);
    handleCloseColorPalette();
  };

  const handleCancel = () => {
    handleCloseColorPalette();
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={handleCancel}
      PaperProps={{
        style: {
          backgroundColor: "#2F355F",
          color: "white",
          padding: "4px",
          borderRadius: "8px",
          marginTop: "60px",
          marginLeft: "90px",
          border: "1px solid rgba(255, 255, 255, 0.2)",
        },
      }}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
    >
      <Box sx={{ bgcolor: "#373E6D" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            bgcolor: "#2F355F",
            p: 1,
          }}
        >
          <HexColorPicker color={tempColor} onChange={setTempColor} />

          <Box
            sx={{
              mt: 1,
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            {/* HEX display */}
            <Box>
              <Box
                sx={{
                  fontFamily: "Inter",
                  fontSize: "12px",
                  fontStyle: "normal",
                  fontWeight: 500,
                }}
              >
                HEX
              </Box>
              <Button
                sx={{
                  backgroundColor: "#373E6D",
                  color: theme === "dark" ? "white" : "black",
                  "&:hover": {
                    backgroundColor: "#373E6D",
                  },
                  padding: "4px 8px",
                  minWidth: "43px",
                  mxnWidth: "43px",
                  minHeight: "20px",
                }}
              >
                {tempColor}
              </Button>
            </Box>

            {/* RGB values */}
            <Box>
              <Box sx={{ display: "flex", flexDirection: "row", gap: "2px" }}>
                {["r", "g", "b"].map((key, index) => (
                  <Box key={key}>
                    <Box
                      sx={{
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontStyle: "normal",
                        fontWeight: 500,
                      }}
                    >
                      {key.toUpperCase()}
                    </Box>
                    <Button
                      sx={{
                        backgroundColor: "#373E6D",
                        color: theme === "dark" ? "white" : "black",
                        "&:hover": {
                          backgroundColor: "#373E6D",
                        },
                        padding: "4px 8px",
                        minHeight: "20px",
                        minWidth: "30px",
                        borderRadius:
                          index === 0
                            ? "4px 0px 0px 4px"
                            : index === 2
                            ? "0px 4px 4px 0px"
                            : "0px",
                      }}
                    >
                      {tempColorRgbCode[key]}
                    </Button>
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>

          {/* Save and Cancel buttons */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 1,
              mt: 2,
            }}
          >
            <Button
              variant="outlined"
              size="small"
              onClick={handleCancel}
              sx={{
                color: "white",
                border:"none",
                "&:hover": {
                color:"rgba(255, 255, 255, 0.8)",
                backgroundColor:"transparent",
                border:"none"
              },
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              size="small"
              onClick={handleSave}
              sx={{
                backgroundColor: button_bg_color_for_New_Project,
                color: "#000000",
                "&:hover": {
                  bgcolor: '#FFD9AA'
                },
              }}
            >
              Save
            </Button>
          </Box>
        </Box>
      </Box>
    </Menu>
  );
};

export default ColorPalette;
